import { render, staticRenderFns } from "./PresentationDocx.vue?vue&type=template&id=428e14fa&scoped=true"
import script from "./PresentationDocx.vue?vue&type=script&lang=js"
export * from "./PresentationDocx.vue?vue&type=script&lang=js"
import style0 from "./PresentationDocx.vue?vue&type=style&index=0&id=428e14fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428e14fa",
  null
  
)

export default component.exports